import { render, staticRenderFns } from "./MailHistory.vue?vue&type=template&id=ee4e84ce&scoped=true&"
import script from "./MailHistory.vue?vue&type=script&lang=js&"
export * from "./MailHistory.vue?vue&type=script&lang=js&"
import style0 from "./MailHistory.vue?vue&type=style&index=0&id=ee4e84ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4e84ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VDataTable,
})
